import { useEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { useQuery } from 'react-query';

import { getCustomerByName, getCustomerConfigById } from '../api/customer/customer';
import {
  CustomersWithCustomElementsE,
  DashboardTypeE,
  TransportTypeCustomersE,
} from '../declarations/enums/common';
import { HttpStatusE } from '../declarations/enums/httpStatus';
import { CustomerConfigI } from '../declarations/interfaces/customer';
import { CUSTOMER_NAME } from '../routes/AppRoutes';

const useInit = () => {
  const [isIE, setIsIE] = useState(false);
  const [customerId, setCustomerId] = useState<string>('');
  const [customerConfig, setCustomerConfig] = useState({} as CustomerConfigI);
  const [errorCode, setErrorCode] = useState<HttpStatusE>();

  const { isLoading: isCustomerLoading, isError } = useQuery(
    ['customer'],
    () => getCustomerByName(CUSTOMER_NAME),
    {
      select: data => data.data,
      onSuccess({ uuid, status }) {
        if (!uuid) {
          setErrorCode(status);

          return;
        }

        // workaround for all urls with uuid includes
        if (window.location.pathname.split('/')[2] === uuid) {
          window.location.replace(`${window.location.origin}/${CUSTOMER_NAME}`);
        }
        setCustomerId(uuid);

        if (uuid == '5e943b9d-58dd-4729-910e-d3a0b64aa628') {
          ReactGA.initialize('UA-97206765-1');
          ReactGA.pageview(window.location.pathname + window.location.search);
        }
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onError(error: any) {
        setErrorCode(error.request.status);
      },
    }
  );

  const { isLoading: isCustomerConfigLoading } = useQuery(
    ['customer-config', customerId],
    () => getCustomerConfigById(customerId),
    {
      enabled: !!customerId,
      onSuccess(data) {
        // TODO remove when this part will be implemented in Admin Panel
        // need for splitting UI parts on the home page
        const dashBoardType =
          data.data.dashBoardType ||
          ((Object.values(TransportTypeCustomersE) as string[]).includes(data.data.customerId) &&
            DashboardTypeE.TRANSPORT) ||
          null;

        // Admin Panel provide only google fonts list, such fonts are not supported by google fonts
        const isSixSensesDouroValleyCustomer =
          data.data.slugUrl === CustomersWithCustomElementsE.SIX_SENSES_DOURO_VALLEY_SAMODAES;
        const font = isSixSensesDouroValleyCustomer
          ? {
              name: 'Avenir Next',
              url: './fonts/Avenir_Next/avenir-next.woff2',
              variant: 'regular',
            }
          : data.data.calculatorThemeDto.font;

        const headersFont = isSixSensesDouroValleyCustomer
          ? {
              name: 'Canto_Roman',
              url: './fonts/Canto_Roman/canto-roman.woff2',
              variant: 'regular',
            }
          : data.data.calculatorThemeDto.font;

        setCustomerConfig({
          ...data.data,
          calculatorThemeDto: { ...data.data.calculatorThemeDto, font, headersFont },
          dashBoardType,
        });
      },
    }
  );

  useEffect(() => {
    window.REACT_APP_RELEASE_ID = process.env.REACT_APP_RELEASE_ID;

    if (navigator.userAgent.indexOf('MSIE') !== -1 || !!document.documentMode === true) {
      //IF IE > 10
      setIsIE(true);
    }
  }, []);

  return {
    isIE,
    customerConfig,
    isConfigLoading: isCustomerLoading || isCustomerConfigLoading,
    isError: (!isCustomerLoading && !customerId) || isError,
    errorCode,
  };
};

export default useInit;
